import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'EXPERIENCE_UPDATE',
    smsDelete : 'EXPERIENCE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        experience:[],
      
        experience_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        experienceLoading: false,
        experienceError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_EXPERIENCE(state, experience) {
            state.experience = experience;
        },

        SET_EXPERIENCE_DETAIL(state, detail) {
            state.experience_detail = detail;
        },

        EXPERIENCE_LOADING (state, loading) {
            state.experienceLoading = loading;
        },

        EXPERIENCE_ERROR (state, hasError) {
            state.experienceError = hasError;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
    },

    actions: {
        //Experiences
        async addExperiences ({commit, dispatch}, payload) {
            commit('EXPERIENCE_LOADING', true);
            commit('EXPERIENCE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_experience, payload.experience, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchExperiences')
               
                return response

            }catch (e) {
                commit('EXPERIENCE_ERROR', true);
            }finally {
                commit('EXPERIENCE_LOADING', false);
            }
        },

        async fetchExperiencesDetail ({ commit },payload) {
            commit('EXPERIENCE_LOADING', true);
            commit('EXPERIENCE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_experience_details + payload, config);
                let response = result.data.data

                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('EXPERIENCE_ERROR', true);
            }
            finally {
                commit('EXPERIENCE_LOADING', false);
            }
        },



        async fetchExperiences ({ commit }) {
            commit('EXPERIENCE_LOADING', true);
            commit('EXPERIENCE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.experience_list, config);
                let response = result.data

                commit('SET_EXPERIENCE', response.data);

            } catch(error) {
                commit('EXPERIENCE_ERROR', true);
            }
            finally {
                commit('EXPERIENCE_LOADING', false);
            }
        },


    
        async updateExperiences ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.update_experience+payload.id, payload.experience, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchExperiences')
                return response

            }catch (e) {
                commit('EXPERIENCE_ERROR', true);
            }finally {
                commit('EXPERIENCE_LOADING', false);
            }
        },

        
        async deleteExperiences({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.experience_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchExperiences')
            
            return response
        },

    },

    getters: {}
}
